import React, { useState, useEffect } from "react";

import { TextField, Button,
  Dialog, DialogActions, DialogContent,
  DialogTitle, Slide, IconButton, Checkbox
} from "@mui/material";


import { IMaskInput } from 'react-imask';
import { crearUsuarios, editarUsuarios } from "../../service/apiService";
import { useForm, Controller } from "react-hook-form";
import { useAppDispatch, useAppSelector } from '../../provider/app/hooks';
import { addItem, updateItem } from '../../provider/Slice/UserSlice';
import { InputStyle, RadioButton, CheckBox} from "../../SXStyle";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogUser({ open, setOpen, registro = null , setSnackbar }) {
  
  const dispatch = useAppDispatch();

  //react-hook-form
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      surname1: "",
      surname2: "",
      email: "",
      status: 1,
      password: "",
      title: "",
      phone: ""
    }
  });

  const handleDialogClose = () => {
    setOpen(false);
  };

  //si es un edit - llena los valores del registro
  //si es un nuevo registro - valores por default
  useEffect(() => {
    console.log({registro})
    if(registro !== null && open)
    {
      reset({
        id: registro.id,
        name: registro.name,
        surname1: registro.surname1,
        surname2: registro.surname2,
        email: registro.email,
        status: registro.status,
        password: registro.password,
        title: registro.title,
        phone: registro.phone
      })
    }
    else if (registro === null && open) {
      reset({
        id: null,
        name: "",
        surname1: "",
        surname2: "",
        email: "",
        status: 0,
        password: "",
        title: "",
        phone: ""
      });
    }

  },[registro, open, reset])

  //guarda el registro
  const onSubmit = async (data) => {
    
    try 
    {
      let result;

      //edita el registro
      if(registro && registro.id)
      {
        result = await editarUsuarios(data  , registro.id);
        dispatch(updateItem(result.data));
      }
      if(data.id === null)
      {
        result = await crearUsuarios(data);
        dispatch(addItem(result.data[0]));
      } 

      //si las credenciales son invalidas
      if (result)
        setSnackbar({ message: result.message, open: true });
    } 
    catch (error) {
      console.log({ error });
      setSnackbar({ message: "Ocurrió un error inesperado, intente de nuevo", open: true });
    }

    //limpia los datos despues de mandar una solicitud
    reset();

    handleDialogClose();
  };


  return (
    <React.Fragment>
      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            backgroundColor: "#555b5e",
            border: "1px solid",
            borderRadius: "10px",
            borderColor: "#555b5e",
          },
        }}
      >
        <DialogTitle>
          <p className="text-white font-bold"> {registro?.id ? "Editar Usuario" : "Crear Usuario" } </p>
        </DialogTitle>

        <DialogContent>
          <form
            id="mi-formulario"
            className="space-y-4 md:space-y-6 h-[380px] overflow-y-scroll"
            onSubmit={handleSubmit(onSubmit)}
            
          >
            <Controller
              name="name"
              control={control}
              rules={{ required: "Campo faltante o inválido" }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Nombre*"
                  className="rounded-lg block w-full bg-inputs border"
                  sx={{ ...InputStyle, marginTop: "10px" }}
                  error={!!errors.name}
                  helperText={errors.name ? "Campo faltante  o inválido" : ""}
                />
              )}
            />

            <Controller
              name="surname1"
              control={control}
              rules={{ required: "Campo faltante o inválido" }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Apellido Paterno*"
                  className="rounded-lg block w-full bg-inputs border"
                  sx={{ ...InputStyle, marginTop: "10px" }}
                  error={!!errors.surname1}
                  helperText={
                    errors.surname1 ? "Campo faltante  o inválido" : ""
                  }
                />
              )}
            />

            <Controller
              name="surname2"
              control={control}
              rules={{ required: "Campo faltante o inválido" }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Apellido Materno*"
                  className="rounded-lg block w-full bg-inputs border"
                  sx={{ ...InputStyle, marginTop: "10px" }}
                  error={!!errors.surname2}
                  helperText={
                    errors.surname2 ? "Campo faltante  o inválido" : ""
                  }
                />
              )}
            />

            <Controller
              name="email"
              control={control}
              rules={{
                required: "Campo faltante o inválido",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Formato de email inválido",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Email*"
                  className="rounded-lg block w-full bg-inputs border"
                  sx={{ ...InputStyle, marginTop: "10px" }}
                  error={!!errors.email}
                  helperText={errors.email ? "Campo faltante  o inválido" : ""}
                />
              )}
            />

            <Controller
              name="status"
              control={control}
              render={({ field }) => (
                <div className="flex">
                  <Checkbox
                    {...field}
                    checked={!!field.value}
                    sx={CheckBox}
                    inputProps={{
                      "aria-label": "select all desserts",
                    }}
                  />
                  <p className="text-white mt-2 font-semibold">
                    ¿Esta activo?
                  </p>
                </div>
              )}
            />

   
            <Controller
              name="title"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Titulo Profesional"
                  className="rounded-lg block w-full bg-inputs border"
                  sx={{ ...InputStyle, marginTop: "10px" }}
                  error={!!errors.title}
                  helperText={errors.title ? "Campo faltante  o inválido" : ""}
                />
              )}
            />

            <Controller
              name="phone"
              control={control}
              rules={{
                required: "Campo faltante o inválido",
                
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Teléfono"
                  className="rounded-lg block w-full bg-inputs border"
                  sx={{ ...InputStyle, marginTop: "10px" }}
                  error={!!errors.phone}
                  helperText={errors.phone ? "Campo faltante  o inválido" : ""}
                  InputProps={{
                    inputComponent: IMaskInput,
                    inputProps: {
                      mask: "(#00) 000-0000",
                      definitions: { "#": /[1-9]/ },
                      overwrite: true
                    },
                  }}
                />
              )}
            />

          </form>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDialogClose}>
            <p className="text-rojo"> Cancelar </p>
          </Button>
          <Button type="submit" form="mi-formulario">
            <p className="text-amarillo"> Aceptar </p>
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default DialogUser;
